'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_magnolia1$002e$002dCase$002dClass from "./magnolia1.-Case-Class.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass(typeInfo, isObject, isValueClass, parameters, annotations, inheritedAnnotations, typeAnnotations, product) {
  this.wa = null;
  this.mh = null;
  this.w9 = null;
  this.Kr = null;
  this.Kr = product;
  $j_magnolia1$002e$002dCase$002dClass.$ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__(this, typeInfo, isObject, isValueClass, parameters, annotations, inheritedAnnotations, typeAnnotations);
}
export { $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass as $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass };
$p = $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass.prototype = new $j_magnolia1$002e$002dCase$002dClass.$h_Lmagnolia1_CaseClass();
$p.constructor = $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass;
/** @constructor */
function $h_Lmagnolia1_CaseClassDerivation$ProductCaseClass() {
}
export { $h_Lmagnolia1_CaseClassDerivation$ProductCaseClass as $h_Lmagnolia1_CaseClassDerivation$ProductCaseClass };
$h_Lmagnolia1_CaseClassDerivation$ProductCaseClass.prototype = $p;
var $d_Lmagnolia1_CaseClassDerivation$ProductCaseClass = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_CaseClassDerivation$ProductCaseClass, "magnolia1.CaseClassDerivation$ProductCaseClass", ({
  nQ: 1,
  nM: 1,
  a: 1
}));
export { $d_Lmagnolia1_CaseClassDerivation$ProductCaseClass as $d_Lmagnolia1_CaseClassDerivation$ProductCaseClass };
